import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { v4 as uuidv4 } from 'uuid'

import RightFileUpload from '../RightFileUpload'
import FileDetailsPreview from '../../../../../../components/FileDetailsPreview'

import { clearUploadedFile, updateFileUploadProgress } from '../../../../../../modules/actions/files'

import { fileTypes } from '../../../../../../pages/Partnerships/PartnershipRightsList/helpers'

import { FILE_TYPE, NEW_FILES } from '../fields'

import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'

function NewFiles({ formik, availableFileTypesList }) {
  const drawerFormClasses = useDrawerFormStyles()

  const dispatch = useDispatch()

  const { values, setFieldValue } = formik

  const handleNewFileUploaded = useCallback(
    file => {
      setFieldValue(NEW_FILES, [
        ...values[NEW_FILES],
        {
          ...file,
          id: uuidv4(),
          type: values[FILE_TYPE]
        }
      ])
    },
    [setFieldValue, values]
  )

  const handleRemoveNewFile = useCallback(
    ({ name, id: removeFileId }) => {
      setFieldValue(
        NEW_FILES,
        values[NEW_FILES].filter(file => file.id !== removeFileId)
      )
      // clear redux storage related to file uploading
      dispatch(updateFileUploadProgress({ [name]: 0 }))
      dispatch(clearUploadedFile(name))
    },
    [dispatch, setFieldValue, values]
  )

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={drawerFormClasses.sectionTitle}>Upload a new file</h3>
      <p>First, select the file type and then upload.</p>
      {values[NEW_FILES].map(file => {
        const fileTypeDetails = fileTypes[file[FILE_TYPE]]

        return (
          <FileDetailsPreview
            key={file.url}
            fileName={file.name}
            fileUrl={file.url}
            FileIcon={fileTypeDetails.icon}
            iconColor={fileTypeDetails.color}
            removeFile={() => handleRemoveNewFile(file)}
            allowDelete
          />
        )
      })}
      <RightFileUpload
        formik={formik}
        onFileUploaded={handleNewFileUploaded}
        availableFileTypesList={availableFileTypesList}
      />
    </section>
  )
}

export default NewFiles
